import { Component, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import {
  AnalystRole,
  UsersService,
} from '@compumark/analyst-selection-tool-client';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GridApi } from 'ag-grid-community';
import { first } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-analyst-roles-admin',
  standalone: false,
  templateUrl: './analyst-roles-admin.component.html',
  styleUrls: ['./analyst-roles-admin.component.scss'],
})
export class AnalystRolesAdminComponent implements OnInit {
  gridApi?: GridApi;

  teamLeads = [
    '',
    'Sylvie Goossens',
    'Rakesh Kanuganti',
    'Zorica Miljenović',
    'Katarina Milosavljević',
    'Tijana Veljković',
  ];

  private teamLeadEmailMap: { [key: string]: string } = {
    'Sylvie Goossens': 'sylvie.goossens@clarivate.com',
    'Rakesh Kanuganti': 'rakesh.kanuganti@clarivate.com',
    'Zorica Miljenović': 'zorica.miljenovic@clarivate.com',
    'Katarina Milosavljević': 'katarina.pavlovic@clarivate.com',
    'Tijana Veljković': 'tijana.veljkovic@clarivate.com',
  };

  userId = '';
  dataSource: AnalystRole[] = [];
  rolesToAdd: string[] = [];
  allRoles: string[] = [];
  userSelected = false;
  selectedRole = '';
  isDrawerOpen = false;
  firstName = '';
  lastName = '';
  email = '';
  teamLead = '';
  refreshUserData = false;

  displayedColumns: string[] = ['role', 'delete'];

  constructor(private usersService: UsersService) {}

  ngOnInit(): void {
    this.getAllRoles();
  }

  getAllRoles(): void {
    this.usersService
      .getAllRoles()
      .pipe(untilDestroyed(this))
      .subscribe((result: string[]) => {
        this.allRoles = result;
      });
  }

  onSearch(): void {
    if (this.userId !== '') {
      this.refreshDataSourceAndRolesToAdd();
      this.userSelected = true;
      this.refreshUserData = !this.refreshUserData;

      this.usersService
        .getAnalystById(this.userId)
        .pipe(first())
        .subscribe({
          next: (analyst) => {
            this.firstName = analyst.firstName ?? '';
            this.lastName = analyst.lastName ?? '';
            this.email = analyst.email ?? '';
            this.teamLead = analyst.teamLead ?? '';
          },
          error: () => {
            this.clearForm();
          },
        });
    }
  }

  deleteRole(role: string): void {
    if (confirm('The user role will be deleted. Do you want to continue?')) {
      this.usersService
        .deleteUserRole(this.userId, role)
        .pipe(first())
        .subscribe(() => {
          this.refreshDataSourceAndRolesToAdd();
          this.refreshUserData = !this.refreshUserData;
        });
    }
  }

  onAddRole(event: MatSelectChange): void {
    this.usersService
      .addUserRole(this.userId, event.value)
      .pipe(first())
      .subscribe(() => {
        this.refreshDataSourceAndRolesToAdd();
        this.refreshUserData = !this.refreshUserData;
      });
  }

  refreshDataSourceAndRolesToAdd(): void {
    this.usersService
      .getUserRoles(this.userId)
      .pipe(first())
      .subscribe((result: AnalystRole[]) => {
        this.dataSource = result;
        this.rolesToAdd = this.allRoles.filter(
          (item) => !this.dataSource.map((d) => d.role).includes(item),
        );
        this.selectedRole = '';
      });
  }

  viewAllUsers(): void {
    this.isDrawerOpen = true;
    this.refreshUserData = !this.refreshUserData;
  }

  saveUserInfo(): void {
    const payload = {
      userId: this.userId,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      teamLead: this.teamLead,
      teamLeadEmail: this.teamLead ? this.teamLeadEmailMap[this.teamLead] : '',
    };
    this.usersService
      .addAnalystData(payload, this.userId)
      .pipe(first(), untilDestroyed(this))
      .subscribe(() => {
        this.onSearch();
      });
  }

  private clearForm(): void {
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.teamLead = '';
    this.dataSource = [];
    this.rolesToAdd = this.allRoles;
  }
}
